const config = {
    "img_baseURL": "https://hosting.prometheuspro.us/img/libauto/",

    "privatelabel": {
        "baseURL": "https://privatelabel.prometheuspro.us",
    },
    "api": {
        "baseURL": "https://api.prometheuspro.us/api",
        "errorURL": "https://apitest.prometheuspro.us/api/error",
        "ver": "pm",
    },
    "exports": {
        "baseURL": "https://api.prometheuspro.us/tmp/",
    },
    "customize": {
        "baseURL": "https://api.prometheuspro.us/api/pm",
    },
    "files": {
        "baseURL": "https://files.prometheuspro.us/files",
    },
    "grafana": {
        "baseURL": "https://analytics.prometheuspro.dev",
    },
}
export default config